import InfoModal, { getInfoProps } from './InfoModal';
export { InfoModal, getInfoProps };
export default InfoModal;